import { Platform } from 'react-native';

/**
 * Network Service für Online/Offline Detection
 */
class NetworkService {
  constructor() {
    this.isOnline = true;
    this.listeners = [];
    
    // Initialize network detection
    this.initializeNetworkDetection();
  }

  /**
   * Initialisiert die Netzwerk-Erkennung
   */
  initializeNetworkDetection() {
    if (typeof window !== 'undefined') {
      // Web: Nutze navigator.onLine und Events
      this.isOnline = window.navigator.onLine;
      
      window.addEventListener('online', () => {
        console.log('🌐 Network: ONLINE');
        this.isOnline = true;
        this.notifyListeners(true);
      });
      
      window.addEventListener('offline', () => {
        console.log('📴 Network: OFFLINE');
        this.isOnline = false;
        this.notifyListeners(false);
      });
    } else {
      // Native: TODO - Hier könnte @react-native-community/netinfo verwendet werden
      console.log('📱 Native network detection not implemented yet');
      this.isOnline = true;
    }
  }

  /**
   * Registriert einen Listener für Netzwerk-Status-Änderungen
   */
  addListener(callback) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter(cb => cb !== callback);
    };
  }

  /**
   * Benachrichtigt alle Listener über Netzwerk-Status-Änderungen
   */
  notifyListeners(isOnline) {
    this.listeners.forEach(callback => {
      try {
        callback(isOnline);
      } catch (error) {
        console.error('❌ Network listener error:', error);
      }
    });
  }

  /**
   * Gibt den aktuellen Netzwerk-Status zurück
   */
  getIsOnline() {
    if (typeof window !== 'undefined') {
      return window.navigator.onLine;
    }
    return this.isOnline;
  }

  /**
   * Prüft die Netzwerkverbindung durch einen Test-Request
   */
  async checkConnection(url = '/api/health') {
    try {
      const response = await fetch(url, {
        method: 'HEAD',
        cache: 'no-cache',
        timeout: 5000
      });
      return response.ok;
    } catch (error) {
      return false;
    }
  }
}

export default new NetworkService();

